export default class GiftCard {
  constructor (data = {}) {
    this.operator = data.operator || null;
    this.card = data.card || null;
    this.quantity = data.quantity || 1;
    this.amount = data.amount || null;
  }
}
